import { axios } from "@redux/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getPlayerTransactionThunk = createAsyncThunk(
  "player/getTransaction",
  async (phoneNumber: string, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/v1/player/${phoneNumber}`, {
        headers: { "Content-Type": "application/json" },
      });

      if (res?.data?.error) {
        return rejectWithValue(res.data.error);
      }

      return res.data;
    } catch (error) {
        return rejectWithValue(error);
      }
    }
);
